import React, { useState } from "react";
import styled from "styled-components";
import Back from "sushiweb/Icons/all/Back";
import Breadcrumb from "sushiweb/Breadcrumb";
import Button from "sushiweb/Button";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import DriverActionModal from "../DriverActionModal";
import { isMobile } from "../../../utils";

const driverActions = [
  {
    label: "Notify",
    key: "notify",
  },
  {
    label: "Terminate",
    key: "terminate",
  },
  {
    label: "Resign",
    key: "resign",
  },
];

const forceOfflineAction = {
  label: "Force offline",
  key: "force_offline",
};

const clearSelfieCampaignAction = {
  label: "Clear selfie campaign",
  key: "clear_selfie_campaign",
};

const verifyDriverAction = {
  label: "Verify",
  key: "verify",
};

const uploadProfileImageAction = {
  label: "Upload Profile Image",
  key: "upload_profile_image",
};

const TopActionBar = ({
  driverDetails,
  driverDocuments,
  handleBackClick,
  handleEditClick,
  editState,
  handleEditCancel,
  handleSaveClick,
  activeLifecycleStatus, //active lifecycle status of driver
  activeIndex, //activeindex of horizontal tabs
  allMenuActions,
}) => {
  const [action, setAction] = useState("");
  const noEditActiveIndexes = ["Assets", "Reservations", "Logs", "Stores"];
  const verifyLifeCycleStatuses = ["dormant"];

  const handleChange = (key, val) => {
    setAction(val);
  };

  const handleClose = () => {
    setAction("");
  };

  const getActionOptions = () => {
    let actions = [...driverActions];
    if (!allMenuActions.DRIVER_NOTIFY) {
      actions.splice(0, 1);
    }
    if (!allMenuActions.DRIVER_LIFECYCLE_EDIT) {
      actions = allMenuActions.DRIVER_NOTIFY ? [driverActions[0]] : [];
    }
    if (allMenuActions.DRIVER_DETAILS_EDIT) {
      actions.push(forceOfflineAction);
    }
    if (allMenuActions.DRIVER_CLEAR_SELFIE_CAMPAIGN) {
      actions.push(clearSelfieCampaignAction);
    }
    if (
      allMenuActions.DRIVER_DOC_VERIFICATION_MANAGER &&
      verifyLifeCycleStatuses.includes(driverDetails?.lifecycle_status)
    ) {
      actions.push(verifyDriverAction);
    }
    if (
      allMenuActions.DRIVER_DOC_VERIFICATION_MANAGER &&
      allMenuActions.DRIVER_DOCUMENTS_EDIT &&
      !driverDocuments?.image
    ) {
      actions.push(uploadProfileImageAction);
    }
    return actions;
  };

  const hasPermission = () => {
    switch (activeIndex) {
      case "Details":
        return allMenuActions.DRIVER_DETAILS_EDIT;
      case "Additional details":
        return allMenuActions.DRIVER_ADDITIONAL_DETAILS_EDIT;
      case "Financial":
        return allMenuActions.DRIVER_FINANCIAL_DETAILS_EDIT;
      case "Services":
        return false;
      case "Localities":
        return allMenuActions.DRIVER_LOCALITIES_DETAILS_EDIT;
      case "Documents":
        return allMenuActions.DRIVER_DOCUMENTS_EDIT;
      case "Assignment status":
        return allMenuActions.DRIVER_ASSIGNMENT_STATUS_EDIT;
      default:
        return true;
    }
  };

  return (
    <TopActionBarContainer className="mb-30">
      <LeftContainer justify="flex-start">
        <Back
          onClick={handleBackClick}
          className="mr-10 backBtn"
          color={variables.grey400}
        />
        <Breadcrumb className="sushi-breadcrumbs">
          <Breadcrumb.Link onClick={handleBackClick}>
            Delivery partners
          </Breadcrumb.Link>
          {Object.keys(driverDetails).length > 0 && (
            <Breadcrumb.Link>{driverDetails.name}</Breadcrumb.Link>
          )}
        </Breadcrumb>
      </LeftContainer>
      {editState && !noEditActiveIndexes.includes(activeIndex) ? (
        <RightContainer flexpct="25">
          <Button
            data-testid="saveDriverDetail"
            onClick={handleSaveClick}
            className="sushi-btn mr-10"
          >
            Save
          </Button>
          <Button
            data-testid="cancelSavingDriverDetail"
            onClick={handleEditCancel}
            className="sushi-btn"
            appearance="outline"
          >
            Cancel
          </Button>
        </RightContainer>
      ) : (
        <RightContainer justify="flex-end">
          {getActionOptions().length > 0 && (
            <PaginatedReactDropdown
              options={getActionOptions()}
              width={isMobile() ? "100%" : "60%"}
              labelKey="label"
              valueKey="key"
              noLabelSelect
              className="actionDropdown"
              handleChange={handleChange}
              value=""
              keyToChange="action"
              placeholder="Take action"
              id={`actionDropdownDeliveryDrivers`}
            />
          )}
          {action && (
            <DriverActionModal
              action={action}
              handleClose={handleClose}
              allMenuActions={allMenuActions}
            />
          )}
          {!noEditActiveIndexes.includes(activeIndex) && hasPermission() && (
            <Button
              data-testid="editDriverDetail"
              onClick={handleEditClick}
              className="sushi-btn ml-20"
              appearance="outline"
              disabled={activeLifecycleStatus === "terminated"}
            >
              Edit
            </Button>
          )}
        </RightContainer>
      )}
    </TopActionBarContainer>
  );
};

const TopActionBarContainer = styled(FlexContainer)`
  flex-direction: ${isMobile() ? "column" : "row"};
`;

const LeftContainer = styled(FlexContainer)`
  flex: 0 1 30%;
  margin-bottom: ${isMobile() ? "20px" : "unset"};
  & > div {
    flex-direction: ${isMobile() ? "row" : "column"};
  }
`;

const RightContainer = styled(FlexContainer)`
  flex: ${({ flexpct }) => (flexpct ? `0 1 ${flexpct}%` : "0 1 35%")};
  .actionDropdown {
    width: 100%;
    margin-bottom: unset;
  }
`;

export default TopActionBar;
